<h2>{{title}}</h2>
<p-table #pt [value]="features" [paginator]="displayPaginator()" [rows]="100" [rowsPerPageOptions]="[25,100,200]"
  [pageLinks]="3" [lazy]="false" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple"
  [multiSortMeta]="multiSortMeta" dataKey="featureId" [scrollable]="false" scrollHeight="500px"
  [style]="{'width':'100%'}">
  <ng-template pTemplate="header">
    <tr>
      <td style="width:115px;">
      </td>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field">{{col.header}}
          <span>
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </span>
        </th>
      }
    </tr>
    <!-- <tr>
    <th *ngFor="let col of columns" [ngSwitch]="col.field">
      <p-multiSelect *ngSwitchCase="'status'" [options]="featureStatusOptions" defaultLabel="Status"
      (onChange)="pt.filter($event.value, col.field, 'in')"></p-multiSelect>

      <input *ngSwitchCase="'featureId'" pInputText type="text"
        (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">

      <input *ngSwitchCase="'description'" pInputText type="text"
        (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
    </th>
  </tr> -->
</ng-template>

<!-- <td [ngStyle]="{'width': '5%','text-align':'center'}"> -->
<ng-template pTemplate="body" let-feature let-columns="columns" let-expanded="expanded">
  <tr>
    <td nowrap>
      <form [formGroup]="featureEditForm">
        <mat-slide-toggle [checked]="isStatusChecked(feature)" (change)="onStatusChange($event,feature )"
        color="accent"></mat-slide-toggle>

        @if (feature.propertyFeatureId) {
          <a href style="margin-left:25px;margin-right:10px;"
            [pRowToggler]="feature" (click)="patchFeature(feature)">
            <mat-icon style="color:grey">edit</mat-icon>
          </a>
        }
      </form>
    </td>

    @if (!feature.propertyFeatureId) {
      <td (click)="patchFeature(feature)">
        {{feature.name}}
      </td>
      <td (click)="patchFeature(feature)">
        {{feature.title}}
      </td>
      <td (click)="patchFeature(feature)">
        {{feature.featureLabel}}
      </td>
      <td (click)="patchFeature(feature)">
        {{feature.featureDesc}}
      </td>
      <td (click)="patchFeature(feature)">
        {{feature.quantity}}
      </td>
      <td (click)="patchFeature(feature)">
        {{feature.distance}}
      </td>
      <td (click)="patchFeature(feature)">
        {{feature.distanceUnit}}
      </td>
    }
    @if (feature.propertyFeatureId) {
      <td [pRowToggler]="feature" (click)="patchFeature(feature)">
        {{feature.name}}
      </td>
      <td [pRowToggler]="feature" (click)="patchFeature(feature)">
        {{feature.title}}
      </td>
      <td [pRowToggler]="feature" (click)="patchFeature(feature)">
        {{feature.featureLabel}}
      </td>
      <td [pRowToggler]="feature" (click)="patchFeature(feature)">
        {{feature.featureDesc}}
      </td>
      <td [pRowToggler]="feature" (click)="patchFeature(feature)">
        {{feature.quantity}}
      </td>
      <td [pRowToggler]="feature" (click)="patchFeature(feature)">
        {{feature.distance}}
      </td>
      <td [pRowToggler]="feature" (click)="patchFeature(feature)">
        {{feature.distanceUnit}}
      </td>
    }

  </tr>
</ng-template>
<div class="container-fluid">
  <ng-template pTemplate="rowexpansion" let-feature let-columns="columns">
    <tr>
      <td style="width:100%; border:2px solid blue;" colspan="8">
        <form [formGroup]="featureEditForm">
          <!-- Master -->

          <div class="row">
            <div class=" col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" maxlength="35" readonly="true">
                @for (validation of validationMessages.name; track validation) {
                  <mat-error>
                    @if (featureEditForm.get('name').hasError(validation.type) && (featureEditForm.get('name').dirty || featureEditForm.get('name').touched)) {
                      <mat-error class="error-message"
                        >
                      {{validation.message}}</mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class=" col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>Descriptive Words</mat-label>
                <input matInput formControlName="title" readonly="{{formReadOnly}}" maxlength="55">
                @for (validation of validationMessages.title; track validation) {
                  <mat-error>
                    @if (featureEditForm.get('title').hasError(validation.type) && (featureEditForm.get('title').dirty || featureEditForm.get('title').touched)) {
                      <mat-error class="error-message"
                        >
                      {{validation.message}}</mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class=" col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>Quantity</mat-label>
                <input matInput formControlName="quantity" readonly="{{formReadOnly}}"
                  maxlength="5">
                @for (validation of validationMessages.quantity; track validation) {
                  <mat-error>
                    @if (featureEditForm.get('quantity').hasError(validation.type) && (featureEditForm.get('quantity').dirty || featureEditForm.get('quantity').touched)) {
                      <mat-error class="error-message"
                        >
                      {{validation.message}}</mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class=" col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>Distance</mat-label>
                <input matInput formControlName="distance" readonly="{{formReadOnly}}"
                  maxlength="35">
                @for (validation of validationMessages.distance; track validation) {
                  <mat-error>
                    @if (featureEditForm.get('distance').hasError(validation.type) && (featureEditForm.get('distance').dirty || featureEditForm.get('distance').touched)) {
                      <mat-error class="error-message"
                        >
                      {{validation.message}}</mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class=" col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>Distance Type</mat-label>
                <mat-select [(value)]="featureEditForm.value.distanceUnit"
                  formControlName="distanceUnit">
                  @for ( stat of distanceUnits; track  stat) {
                    <mat-option [value]="stat.value">
                    {{stat.name}} </mat-option>
                  }
                </mat-select>
                @for (validation of validationMessages.distanceUnit; track validation) {
                  <mat-error>
                    @if (featureEditForm.get('distanceUnit').hasError(validation.type) && (featureEditForm.get('distanceUnit').dirty || featureEditForm.get('distanceUnit').touched)) {
                      <mat-error class="error-message"
                        >
                        {{validation.message}}
                      </mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>


          <div class="row">
            <mat-form-field class="col-lg-12">
              <mat-label>Description</mat-label>
              <textarea matInput formControlName="featureDesc" readonly="{{formReadOnly}}"
              matTextareaAutosize matAutosizeMinRows=6 matAutosizeMaxRows=500></textarea>
              @for (validation of validationMessages.featureDesc; track validation) {
                <mat-error>
                  @if (featureEditForm.get('featureDesc').hasError(validation.type) && (featureEditForm.get('featureDesc').dirty || featureEditForm.get('featureDesc').touched)) {
                    <mat-error class="error-message"
                      >
                    {{validation.message}} </mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>
            <div class="col-lg-12">
              <button mat-raised-button color="primary"
                (click)="formUpdate(feature); pt.toggleRow(feature)"
              style="float: right;">Update</button>
            </div>
          </div>
        </form>
      </td>
    </tr>

  </ng-template>
</div>
<ng-template pTemplate="paginatorleft" style="font-size:80%"> {{recordTotal}} Features. </ng-template>
</p-table>